import { render, staticRenderFns } from "./index.vue?vue&type=template&id=771beee0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771beee0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('771beee0')) {
      api.createRecord('771beee0', component.options)
    } else {
      api.reload('771beee0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=771beee0&scoped=true", function () {
      api.rerender('771beee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/order/index.vue"
export default component.exports